import request from '@/utils/request'
import {getToken} from '../utils/auth'

export function login (name, password) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      name,
      password
    }
  })
}

export function logout (token) {
  return request({
    url: '/logout',
    method: 'get',
    params: { token }
  })
}

// 验证密码
export function verifypwd (data) {
  return request({
    url: '/verifypwd',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js